/**
 * Alert API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndicatorCategoryDto } from './indicator-category';


export interface AlertReportDetailDto { 
    id: string;
    /**
     * ID do registro deste alerta específico
     */
    registryId?: string;
    document?: string;
    /**
     * ID da empresa titular (Root) ao qual este alerta pertence
     */
    rootRegistryId?: string;
    /**
     * Nível societário do alerta
     */
    relationshipLevel?: AlertReportDetailDto.RelationshipLevelEnum;
    indicatorId: string;
    indicatorName: string;
    category: IndicatorCategoryDto;
    indicatorGroup: string;
    previousValue?: string;
    currentValue: string;
    variation: string;
}
export namespace AlertReportDetailDto {
    export const RelationshipLevelEnum = {
        Root: 'ROOT',
        L1: 'L1',
        L2: 'L2'
    } as const;
    export type RelationshipLevelEnum = typeof RelationshipLevelEnum[keyof typeof RelationshipLevelEnum];
}


